<template>
	<div class="header2" :class="scrollPosition>10?'header2-bgwhite':''">  
		<div class="header-b">
			<div class="header-l">
				<img src="../../assets/logo1.png" alt="">
			</div>
			<div class="header-r">
				<div :class="pathname==item.key?'selectDiv':''" v-for="(item, index) in list"
					@click="taplist(index, item)">
					{{item.enname}}
				</div>
			</div>
			<img @click="tapShowMobile" class="header-menu" src="../../../public/images/menu.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header',
		props: {
			pathname: {
				type: String,
			}
		},
		watch: {
			pathname(newval, oldval) {
				console.log(newval, oldval, "9999999")
			}
		},
		data() {
			return {
				list: [{
						name: "首页",
						enname:"Home",
						key: "/en/index",
						path: "/en/index"
					},
					{
						name: "关于我们",
						enname:"Chinese Overview",
						key: "/en/about",
						path: "/en/about"
					},
					{
						name: "业务与服务",
						enname:"Services",
						key: "/en/service",
						path: "/en/service"
					},
					{
						name: "应用场景",
						enname:"Application",
						key: "/en/product",
						path: "/en/product"
					},
					{
						name: "项目案例",
						enname:"Case",
						key: "/en/case",
						path: "/en/case"
					},
					{
						name: "新闻媒体",
						enname:"Medium",
						key: "/en/medium",
						path: "/en/medium"
					},
					{
						name: "下载中心",
						enname:"Download",
						key: "/en/download",
						path: "/en/download"
					},
					{
						name: "联系我们",
						enname:"Contact Us",
						key: "/en/contactus",
						path: "/en/contactus"
					},
					{
						name: "招贤纳士",
						enname:"Attract talents",
						key: "/en/hire",
						path: "/en/hire"
					},
                    {
                    	name: "中文",
                    	enname:"CN",
                    	key: "/",
                    	path: "/"
                    },
				],
				scrollPosition:0,
			}
		},
		created() {
			var that = this
			window.addEventListener('scroll', function(){
				 that.scrollPosition = window.scrollY || document.documentElement.scrollTop;
			});
		
		},
		
		
		  beforeDestroy() {
		    window.removeEventListener('scroll', this.handleScroll);
		  },
		methods: { 
			getBaseUrl(url) {
			    return url.split('?')[0];
			},
			taplist(index, item) {
				console.log(item.key, "111")
				
				if(item.key == '/'){
					var currentURL = window.location.href;
					if (currentURL.includes("index")) {
					    this.$router.push("/en")
					}else if (currentURL.includes("about")) {
					    this.$router.push("/about")
					}else if (currentURL.includes("service")) {
					    this.$router.push("/service")
					}else if (currentURL.includes("product")) {
					    this.$router.push("/product")
					}else if (currentURL.includes("case")) {
					    this.$router.push("/case")
					}else if (currentURL.includes("medium")) {
					    this.$router.push("/medium")
					}else if (currentURL.includes("download")) {
					    this.$router.push("/download")
					}else if (currentURL.includes("contactus")) {
					    this.$router.push("/contactus")
					}else if (currentURL.includes("hire")) {
					    this.$router.push("/hire")
					}else {
					    this.$router.push("/")
					}
				}else if (item.key == '/en/index') {
					this.$router.push("/en")
				} else {
					this.$router.push(item.key)
				}
				
				
			},
			tapShowMobile() {
				console.log("showMobile1111")
				this.$emit("showMobile", "")
			}
		}
	}
</script>

<style lang="scss">
	
	.header2 {
		width: 100%;
		// background-color: white;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		color: #332C2B;
		justify-content: center;

		.header-b {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.header-l {}

			.header-r {

				justify-content: flex-end;
				align-items: center;

				div {

					box-sizing: border-box;
					cursor: pointer;
				}

				.selectDiv {
					color: #22A3D3;
					border-bottom: 2px solid #22A3D3;
				}
			}

			.header-menu {
				width: 20px;
				height: 20px;
			}
		}
	}
	.header2:hover {
		background-color: white;
	}
	.header2-bgwhite {
		background-color: white;
	}

	@media screen and (min-width: 1200px) {
		.header2 {
			display: flex;
			height: 100px;
			font-size: 16px;

			.header-b {
				width: 1200px;
				height: 100%;

				.header-l {
					width: 20%;
					max-width: 160px;

					img {
						width: 100%;
					}
				}

				.header-r {
					display: flex;
					height: 90px;

					div {
						line-height: 100px;
						height: 100px;
						font-size: 16px;
						margin-left: 15px;
						margin-right: 15px;
					}
				}

				.header-menu {
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.header2 {
			display: flex;
			height: 80px;
			font-size: 15px;

			.header-b {
				width: 100%;
				height: 100%;

				.header-l {
					width: 120px;

					img {
						width: 100%;
					}
				}

				.header-r {
					display: flex;
					height: 100%;

					div {
						line-height: 80px;
						height: 80px;
						font-size: 14px;
						margin-left: 8px;
						margin-right: 8px;
					}
				}

				.header-menu {
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 880px) {
		.header2 {
			padding: 0 12px;
			box-sizing: border-box;
			display: flex;
			height: 50px;
			font-size: 14px;

			.header-b {
				width: 100%;
				height: 100%;

				.header-l {
					width: 80px;
					img {
						width: 100%;
					}
				}

				.header-r {
					display: none;
				}

				.header-menu {
					display: block;
				}
			}
		}
	}


	// @media screen and (min-width: 1200px) {

	// }
	// @media screen and (max-width: 1200px) {

	// }
	// @media screen and (max-width: 880px) {

	// }
</style>
